import MiChip from './MiChip.vue'

export default MiChip
